import React, { useEffect } from 'react'
import { PageLoading } from '@ant-design/pro-layout'

let lock = false
let timer

export default ({ size = 'large' }) => {
    useEffect(() => {
        timer && clearTimeout(timer)

        timer = setTimeout(() => {
            lock = true
        }, 150)

        return () => {
            timer && clearTimeout(timer)
            lock = false
        }
    }, [lock])

    if (lock) {
        return null
    }

    return (
        <div style={{ paddingTop: '10%' }}>
            <PageLoading size={size} />
        </div>
    )
}
